// 1. CREATE API TYPES
export const CREATE_INDUSTRY_REQUEST = "CREATE_INDUSTRY_REQUEST";
export const CREATE_INDUSTRY_SUCCESS = "CREATE_INDUSTRY_SUCCESS";
export const CREATE_INDUSTRY_FAILURE = "CREATE_INDUSTRY_FAILURE";

// 2. GET ALL API TYPES
export const GET_ALL_INDUSTRY_REQUEST = "GET_ALL_INDUSTRY_REQUEST";
export const GET_ALL_INDUSTRY_SUCCESS = "GET_ALL_INDUSTRY_SUCCESS";
export const GET_ALL_INDUSTRY_FAILURE = "GET_ALL_INDUSTRY_FAILURE";

// 3. GET ONE API TYPES
export const GET_ONE_INDUSTRY_REQUEST = "GET_ONE_INDUSTRY_REQUEST";
export const GET_ONE_INDUSTRY_SUCCESS = "GET_ONE_INDUSTRY_SUCCESS";
export const GET_ONE_INDUSTRY_FAILURE = "GET_ONE_INDUSTRY_FAILURE";

// 4. EDIT/UPDATE API TYPES
export const EDIT_INDUSTRY_REQUEST = "EDIT_INDUSTRY_REQUEST";
export const EDIT_INDUSTRY_SUCCESS = "EDIT_INDUSTRY_SUCCESS";
export const EDIT_INDUSTRY_FAILURE = "EDIT_INDUSTRY_FAILURE";

// 5. DELETE API TYPES
export const DELETE_INDUSTRY_REQUEST = "DELETE_INDUSTRY_REQUEST";
export const DELETE_INDUSTRY_SUCCESS = "DELETE_INDUSTRY_SUCCESS";
export const    DELETE_INDUSTRY_FAILURE = "DELETE_INDUSTRY_FAILURE";   


export const UPLOADCSV_INDUSTRY_MASTER_REQUEST = "UPLOADCSV_INDUSTRY_MASTER_REQUEST";
export const UPLOADCSV_INDUSTRY_MASTER_SUCCESS = "UPLOADCSV_INDUSTRY_MASTER_SUCCESS";
export const UPLOADCSV_INDUSTRY_MASTER_FAILURE = "UPLOADCSV_INDUSTRY_MASTER_FAILURE";